document.addEventListener('click', function (event) {
  const button = event.target.closest('#ammo-updates-popup-trigger');

  if (!button) return;

  event.preventDefault();

  window.omnisend = window.omnisend || [];
  window.omnisend.push([
    'openForm',
    '6a51ad02f39c1ca7f39a8d67'
  ]);
});